<div class="headpower-layout">
    <div class="headpower-catalog">
        @if (!mobile && firstLoadingDone) {
            <hpo-card-content class="supplier-products">
                <div class="changelog-btn__container">
                    <a class="changelog-btn"
                        routerLink="/changelog">
                        {{ 'default.toChangelog' | blah }}
                    </a>
                </div>
                <div>
                    @if (resultCount) {
                        <app-catalog-tag-list [tags]="tags"
                            [tagGroups]="tagGroups"
                            [selectedTags]="selectedTags"
                            [selectableTags]="selectableTags"
                            (emitSelectedTags)="updateSelectedTags($event)">
                        </app-catalog-tag-list>
                    }
                </div>
                @if (hasCompanysInstructions) {
                    <div class="supplier-products__container">
                        <div class="supplier-products-title">{{ 'default.companysInstructions' | blah }}:</div>
                        <app-product-list [GroupPriority]="localGroupPriority.SUPPLIER"
                            [products]="products"
                            [stacked]="true"
                            [catalogView]="true"
                            [selectedProductId]="selectedProductId"
                            (emitProductSelect)="selectProduct($event)">
                        </app-product-list>
                    </div>
                }
            </hpo-card-content>
        }

        <hpo-card-content class="headpower-items">
            @if (!firstLoadingDone) {
                <hpo-placeholder type="row"></hpo-placeholder>
            }
            @if (firstLoadingDone) {
                <app-catalog-inline-search [keyword]="keyword"
                    [placeholder]="'default.searchWithHelmi'"
                    (handleSearch)="onKeywordChange($event)"
                    (handleAiSearch)="handleAiSearch($event)">
                </app-catalog-inline-search>
            }

            @if (mobile && firstLoadingDone) {
                <div class="changelog-btn__container mobile">
                    <a class="changelog-btn"
                        routerLink="/changelog">
                        {{ 'default.toChangelog' | blah }}
                    </a>
                </div>
                <mat-chip-listbox class="mobile_taglist">
                    @if (selectedProductId) {
                        <mat-chip-option (removed)="removeTag(undefined, 'product')">
                            {{productName}}
                            <button matChipRemove>
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-chip-option>
                    }
                    @for (tag of selectedTags; track tag) {
                        <mat-chip-option (removed)="removeTag(tag, 'tag')">
                            {{tag.attributes.name}}
                            <button matChipRemove>
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-chip-option>
                    }
                </mat-chip-listbox>
            }

            <app-catalog-content (emitTagGroups)="updateTagGroups($event)"
                (emitTags)="updateTags($event)"
                (emitSelectableTags)="updateSelectableTags($event)"
                (emitResultCount)="updateResultCount($event)"
                [keyword]="keyword"
                [selectedProductId]="selectedProductId"
                [selectedTags]="selectedTags"
                [products]="products"
                [prefix]="PREFIX"
                [productName]="productName"
                [changelog]="true"
                [mobile]="mobile"
                [showAiSearch]="true"
                [aiSearchData]="aiSearchData">
            </app-catalog-content>
        </hpo-card-content>
    </div>
</div>

<ng-template #noInstructions>
    <hpo-placeholder type="row"></hpo-placeholder>
    <hpo-placeholder type="row"></hpo-placeholder>
    <hpo-placeholder type="row"></hpo-placeholder>
</ng-template>

@if (mobile) {
    <hpo-bottom-nav>
        <hpo-nav-item icon="list"
            (click)="mobileProducts()">
            {{ 'default.companysInstructions' | blah }}
        </hpo-nav-item>
        <hpo-nav-item icon="filter_list"
            (click)="mobileTags()">
            {{ 'default.keywords' | blah }}
        </hpo-nav-item>
    </hpo-bottom-nav>
}